"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = exports.createLogger = void 0;
const logger_1 = require("./logger");
const createLogger = (defaultData, defaultMeta, defaultLabels) => {
    return new logger_1.Logger(defaultData, defaultMeta, defaultLabels);
};
exports.createLogger = createLogger;
exports.logger = (0, exports.createLogger)();
//# sourceMappingURL=index.js.map